import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createTheme,ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import store from "./store/store"
import {Provider} from "react-redux"

// Network status handler
const setupNetworkStatusListener = () => {
  const handleOnline = () => {
    console.log('Network connection restored');
    // When the app comes back online, check if the user is still authenticated
    // by checking the local storage and session validity
    const adminData = localStorage.getItem('adminData');
    const customerData = localStorage.getItem('customerData');
    const staffData = localStorage.getItem('staffData');
    
    if (!adminData && !customerData && !staffData) {
      // If no login data, redirect to login
      window.location.href = '/';
    } else {
      // Optionally refresh the page to reload data
      // Only refresh if not already on sign-in page
      if (window.location.pathname !== '/' && window.location.pathname !== '/signin') {
        window.location.reload();
      }
    }
  };

  const handleOffline = () => {
    console.log('Network connection lost');
    // Optionally show a notification to the user
  };

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
};

// Setup network status listener
setupNetworkStatusListener();

let theme = createTheme({
    palette: {
      success: {
        main: '#A7B778',
      },
    },
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
        </Provider>
      </ThemeProvider>    
    </BrowserRouter>
  </React.StrictMode>
);